import { useState } from "react";
import "../src/assests/hot-fixes.scss";
import "./App.css";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Amplify } from "aws-amplify";
import config from "./config.json";
import AppRoutes from "./appRoutes";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/pro-solid-svg-icons";
import { far } from "@fortawesome/pro-regular-svg-icons";
import { Toaster } from "react-hot-toast";
import { IntlProvider } from "react-intl";
import French from "./i18n/fr.json";
import English from "./i18n/en.json";


library.add(fas, far);
export default function App() {
  const [locale, setLocale] = useState("en");
  const messages = loadLocaleData(locale);
  // Amplify.configure(config.amplify.Auth);

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.amplify.Auth.userPoolId,
        userPoolClientId: config.amplify.Auth.userPoolWebClientId,
        identityPoolId: config.amplify.Auth.identityPoolId,
      },
    },
    Storage: {
      S3: {
        bucket: config.Storage.AWSS3.bucket,
        region: config.Storage.AWSS3.region,
      },
    },
    API: {
      Events: {
        endpoint: config.Events.endpoint,
        region: config.Events.region,
        defaultAuthMode: "apiKey" as const,
        apiKey: config.Events.apiKey,
      },
      REST: {
        MyAPI: {
          endpoint: config.API.URL,
          region: config.Storage.AWSS3.region, // Using same region as S3
        },
      },
    },
  });

  function loadLocaleData(locale: string) {
    switch (locale) {
      case "fr":
        return French;
      default:
        return English;
    }
  }

  return (
    <div>
      <Authenticator hideSignUp>
        <IntlProvider locale={locale} defaultLocale={"en"} messages={messages}>
          <AppRoutes></AppRoutes>
        </IntlProvider>
        <Toaster toastOptions={{ duration: 5000, position: "bottom-center" }} />
      </Authenticator>
    </div>
  );
}
